<p-dropdown
  [attr.data-testId]="dataTestId"
  [options]="$any(options)"
  [optionLabel]="$any(optionLabel)"
  [optionValue]="$any(optionValue)"
  [optionDisabled]="optionDisabled || ''"
  [filter]="$any(filter)"
  [styleClass]="styleClass || ''"
  [style]="style"
  [panelStyleClass]="panelStyleClass || ''"
  [filterBy]="$any(filterBy)"
  [placeholder]="$any(placeholder)"
  [emptyFilterMessage]="$any(emptyFilterMessage)"
  [readonly]="!!readonly"
  [resetFilterOnHide]="!!resetFilterOnHide"
  [appendTo]="appendTo"
  [group]="!!group"
  [ngModel]="selectedValue"
  [disabled]="!!disabled"
  [autoDisplayFirst]="!!autoDisplayFirst"
  [showClear]="!!showClear"
  (ngModelChange)="selectedValueChangeHandler($event)"
>
  @if (templatesAsInput) {
    @for (template of templatesAsInput; track template) {
      <ng-template let-item [pTemplate]="template.name" [type]="template.type">
        <ng-container
          *ngTemplateOutlet="template.template; context: { $implicit: item }"
        ></ng-container>
      </ng-template>
    }
  }
  @if (!templatesAsInput) {
    @for (template of templates; track template) {
      <ng-template let-item [pTemplate]="template.name" [type]="template.type">
        <ng-container
          *ngTemplateOutlet="template.template; context: { $implicit: item }"
        ></ng-container>
      </ng-template>
    }
  }
</p-dropdown>
